import { useContext, useState } from 'react';
import { store } from 'components/Store';
import { FilterItem } from './CommonFilter';

const VISIBLE_TEAMMATES = 5;

const TeammatesFilter = ({ filter, selectOption, showTitle, idPrefix = '' }) => {
  const { name, options: propOptions, filterName } = filter;
  const { state } = useContext(store);
  const { team } = state ?? {};
  const [showAllTeammates, setShowAllTeammates] = useState(false);

  const meOption = propOptions.find((option) => option.useCurrentUserId) ?? { name: 'Me', useCurrentUserId: true };
  const teammateOptions = (team?.allMembers ?? [])
    .filter((member) => `${member.id}` !== `${team?.myself?.id}`)
    .sort((a, b) => a.fullName.localeCompare(b.fullName))
    .map(
      (member) =>
        propOptions.find((option) => option.filterValue === `${member.id}`) ?? {
          name: member.fullName,
          filterValue: `${member.id}`,
          hash: `${member.id}`,
        }
    );

  const hasMore = teammateOptions.length > VISIBLE_TEAMMATES;
  const allOptions = [meOption, ...teammateOptions];
  const visibleOptions = showAllTeammates ? allOptions : [meOption, ...teammateOptions.slice(0, VISIBLE_TEAMMATES)];

  const changeFilter = (selected, index) => {
    const newValue = [...allOptions];
    newValue[index] = { ...newValue[index], selected: !selected };
    selectOption({ filter, newValue });
  };

  const optionItems = visibleOptions.map((option, index) => (
    <FilterItem
      key={option.filterValue ?? 'me'}
      option={option}
      index={index}
      changeFilter={changeFilter}
      notRow={!showTitle}
      filterName={filterName}
      idPrefix={`${idPrefix}${option.filterValue ?? 'me'}-`}
    />
  ));

  return (
    <div className='mb-3'>
      {showTitle && <h3>{name}</h3>}
      {showTitle ? <div className='d-flex flex-column row'>{optionItems}</div> : optionItems}
      {hasMore && !showAllTeammates && (
        <button
          type='button'
          className='mt-2 d-inline-block simple-link-button general-button showitem-button'
          onClick={() => setShowAllTeammates(true)}
        >
          See more
        </button>
      )}
    </div>
  );
};

export default TeammatesFilter;
